import { EBuildingClassType } from '../../../../json_query';
import { IBuildingClassTypesTag } from '../../../state/tags/definitions/building_class';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const getDisplayName = (value: string) => `Класс ${value}`;

const buildingClassMap = {
  [EBuildingClassType.APlus]: getDisplayName('A+'),
  [EBuildingClassType.A]: getDisplayName('A'),
  [EBuildingClassType.BPlus]: getDisplayName('B+'),
  [EBuildingClassType.B]: getDisplayName('B'),
  [EBuildingClassType.BMinus]: getDisplayName('B-'),
  [EBuildingClassType.C]: getDisplayName('C'),
};

export const BuildingClassTypesTagItem = getMultiSelectionParamTagItem<EBuildingClassType, IBuildingClassTypesTag>(
  buildingClassMap,
);
